var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"specificity",staticClass:"specificity",style:({
  width:("calc(100%/" + _vm.len + ".25)") ,
  backgroundColor : this.realSelected ? this.selectedBackgroundColor : this.unselectedBackgroundcolor ,
  color : this.realSelected ? '#fff' : '#000'
  }),on:{"mouseenter":_vm.handleMouseEnter,"mouseleave":_vm.handleMouseLeave,"click":function($event){_vm.handleClick(_vm.specificity)}}},[_vm._v("\n    "+_vm._s(_vm.specificity)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-480f1ffd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/ContactUs/SpecificityItem.vue
// module id = null
// module chunks = 